import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { formatRands } from "@/lib/order";
import { StaffShell } from "@/components/layout/StaffShell";
import { adminNav } from "@/lib/nav";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { CenterSpinner, EmptyState } from "@/components/common/States";

export default function AdminDrivers() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-drivers"], queryFn: () => api("/admin/drivers") });

  return (
    <StaffShell items={adminNav} roleLabel="Admin" title="Drivers">
      {isLoading ? (
        <CenterSpinner />
      ) : !data?.length ? (
        <EmptyState title="No drivers yet" />
      ) : (
        <Card className="overflow-hidden rounded-2xl">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Driver</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Deliveries</TableHead>
                <TableHead>Lifetime earnings</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((d) => (
                <TableRow key={d.user_id} data-testid={`admin-driver-${d.user_id}`}>
                  <TableCell>
                    <p className="font-medium">{d.name || "—"}</p>
                    <p className="text-xs text-muted-foreground">{d.email}</p>
                  </TableCell>
                  <TableCell>
                    <Badge className={`rounded-full font-normal ${d.is_online ? "bg-[hsl(var(--success))]/15 text-[hsl(var(--success))]" : "bg-muted text-muted-foreground"}`}>
                      {d.is_busy ? "On delivery" : d.is_online ? "Online" : "Offline"}
                    </Badge>
                  </TableCell>
                  <TableCell>{d.total_deliveries ?? 0}</TableCell>
                  <TableCell>{formatRands(d.total_earnings)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </StaffShell>
  );
}
